import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/account-setup/userforshipperrequest'
import pathMap from 'src/paths/PathMap_AccountSetup'

class UserForShipperRequestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.USER_FOR_SHIPPER_REQUEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.USER_FOR_SHIPPER_REQUEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.USER_FOR_SHIPPER_REQUEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.USER_FOR_SHIPPER_REQUEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default UserForShipperRequestRoute
